"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var areServerDatesEqual_1 = require("./areServerDatesEqual");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return areServerDatesEqual_1.default; } });
//# sourceMappingURL=index.js.map